import CRMStatusChip from '@components/Common/CRMStatusChip';
import type { DeliveryTone } from '@helpers/emailDelivery';

/**
 * A delivery problem as a chip: red for final (hard bounce, complaint, blocked), amber for the
 * kind that may clear up (a transient bounce, repeated soft bounces).
 *
 * One component for the Send Log, the Blocked addresses tab and the account pages, so the three
 * cannot drift into three reds. It is CRMStatusChip with the delivery states, not a chip of its
 * own: it used to carry its own --red/--amber, a second red beside every other failure chip.
 */
const DeliveryChip: React.FC<{ label: string; tone: DeliveryTone }> = ({ label, tone }) => (
  <CRMStatusChip status={tone === 'error' ? 'deliveryFinal' : 'deliveryWarning'} label={label} />
);

export default DeliveryChip;
